import { Component, OnInit, Input, TemplateRef, Output, EventEmitter } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { G_PurchaseMasterViewModel } from 'src/app/viewmodels/g-purchase/G_PurchaseMasterViewModel';
import { ActivatedRoute, Router } from '@angular/router';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { HttpClient } from '@angular/common/http';
import { DefineAccountviewModel } from 'src/app/viewmodels/g-customer/DefineAccountviewModel';
import { GItemDefiningViewModel } from 'src/app/viewmodels/g-item/GItemDefiningViewModel';
import { ItemViewModel, ItemViewModel1 } from 'src/app/viewmodels/ItemViewModel';
import Swal from 'sweetalert2';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { G_Installment_View_Model } from 'src/app/viewmodels/g-purchase/G_Installment_View_Model';
// import { parse } from 'querystring'; // Not available in browser - unused
import { NgForm } from '@angular/forms';
import { G_SaleMasterViewModel } from 'src/app/viewmodels/g-sale/G_SaleMasterViewModel';
import { G_Bulk_Installment_View_Model } from 'src/app/viewmodels/g-purchase/G_Bulk_Installment_View_Model';
import { LocalStorageService } from 'src/app/services/common/local-storage.service';
import { SaveGInstallmentRequest, SavePurchaseMasterRequest, SaveSaleMasterRequest } from 'src/app/viewmodels/g-purchase/GPurchaseViewModel';
import { AppConsts } from 'src/app/common/app-consts';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-purchase-installment',
  templateUrl: './purchase-installment.component.html',
  styleUrls: ['./purchase-installment.component.scss']
})
export class PurchaseInstallmentComponent implements OnInit {

  @Input() public bsmRef: BsModalRef;
  @Output() onSubmitted = new EventEmitter<any>();
  public SortBy: string = "asc";
  public modalRef: BsModalRef;
  public vm: SavePurchaseMasterRequest = new SavePurchaseMasterRequest();
  public vmS: SaveSaleMasterRequest = new SaveSaleMasterRequest();
  public vmListItems: any = [];
  public vmDirectList: any = [];
  public vmListItem: any = [];
  public vmD: DefineAccountviewModel = new DefineAccountviewModel();
  public vmI: SaveGInstallmentRequest = new SaveGInstallmentRequest();
  public bulkInstallment: G_Bulk_Installment_View_Model = new G_Bulk_Installment_View_Model();
  public bulkbyid: any = [];
  p: number = 1;
  dataTable: any;
  @Input('dataTable') table;
  dtOption: any = {};
  public component_Title = 'Installment History';
  public refid: number;
  public total: number;
  public paidamount: number;
  public balance: number;
  public calingUrl: string;
  public urlId: string;
  public isPreview: boolean = false;
  private submitted = false;
  public suppliers: any = [];
  public selectedSuppliers: any = [];
  public selectedSpareParts: any = [];
  public accountList: ItemViewModel1[] = [];
  public purchaseRequisitions: any = [];
  public cpurchaseRequisitions = 'purchaseRequisitions';
  public selectedPurchaseRequisitions: any = [];
  public nowDate: Date;
  public accountDropdownSettings: IDropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 4,
    allowSearchFilter: true
  };
  public isEdit = false;
  public client: any;
  constructor(
    private route: ActivatedRoute,
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private http: HttpClient,
    public _router: Router,
    private _localStorageService: LocalStorageService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    debugger
    this.client = this._localStorageService.get("com");
    this.spinner.show();
    this.nowDate = new Date();
    this.vmI.transactionDate = new Date();
    if (this.vm == undefined) {
      this.vm = new SavePurchaseMasterRequest();
      this.vm.transactionDate = new Date();
      this.vm.paymentType = 1;
      this.vm.purchaseDetail = [];
      this.vm.vatValue = parseInt(this.client.Vat);
      this.vm.invAmount = 0;
      this.vm.paidAmount = 0;
      this.getRefid();
    }
    if (this.vmI == undefined) {
      this.vmI = new SaveGInstallmentRequest();
      this.vmI.transactionDate = new Date();
      this.vmI.debitAccount = new ItemViewModel1();
      this.vmI.debitAccount.id = 0;
      this.vmI.debitAccount.name = "";
      this.vmI.gPurchase = new ItemViewModel1;
      this.vmI.gPurchase.id = 0;
      this.vmI.gPurchase.name = "";
      this.vmI.gSale = new ItemViewModel1;
      this.vmI.gSale.id = 0;
      this.vmI.gSale.name = "";
      this.vmI.creditAccount = new ItemViewModel1;
      this.vmI.creditAccount.id = 0;
      this.vmI.creditAccount.name = "";
      this.vmI.amount = 0;
      this.vmI.remarks = "";
      this.vmI.id = 0;
      this.vmI.isPurchase = false;
      this.vmI.attachment = "";
    }
    if (this.vmS == undefined) {
      this.vmS = new SaveSaleMasterRequest();
      this.vmS.transactionDate = new Date();
      this.vmS.paymentType = 1;
      this.vmS.saleDetails = [];
      this.vmS.customerAcc = new ItemViewModel1();
      this.vmS.customerAcc.id = 0;
      this.vmS.customerAcc.name = "";
      this.getRefSId();
    }
    this.calingUrl = this._router.url;
    this.route.queryParams.subscribe(params => {
      this.urlId = params['id'];
    });
    debugger

    this.getAccount('CaB');

    if (this.calingUrl.startsWith('/purchase')) {
      this.spinner.show();
      debugger
      this._uow.gPurchaseService.GetGPurchaseByIdAsync(this.urlId).subscribe((res: any) => {
        debugger
        this.vmListItem = res;
        this.vm = res;
        this.getList();
        console.log(res);
        this.spinner.hide();
      }, (err) => {
        this.spinner.hide();
        console.log(err);
      })
    }

    if (this.calingUrl.startsWith('/direct-sale-dtl-view')) {
      // this._jq.showSpinner(true);
      debugger
      this._uow.saleService.GetById(this.urlId).subscribe((res: any) => {
        this.vmListItem = res;
        this.vmS = res;
        this.getSaleList();
        console.log(res);
        this._jq.showSpinner();
      }, (err) => {
        console.log(err);
      })
    }

    if (this.calingUrl.startsWith('/direct-sale-list')) {
      ///this._jq.showSpinner(true);
      debugger
      this._uow.gSaleService.GetGSaleByIdAsync(this.urlId).subscribe((res: any) => {
        this.vmListItem = res;
        this.vmS = res;
        this.getSaleList();
        console.log(this.vmS);
        //this._jq.showSpinner();
      }, (err) => {
        console.log(err);
      })
    }

    if (this.calingUrl.startsWith('/payment-status')) {
      this._jq.showSpinner(true);
      debugger
      this._uow.gSaleService.GetGSaleByIdAsync(this.urlId).subscribe((res: any) => {
        this.vmListItem = res;
        this.vmS = res;
        this.getSaleList();
        console.log(res);
        this._jq.showSpinner();
      }, (err) => {
        console.log(err);
      })
    }

    this.spinner.hide();

  }

  getList() {
    this.spinner.show();
    debugger
    this._uow.gPurchaseService.GetGInstallmentByPurchaseIdAsync(this.urlId).subscribe((res: any) => {
      debugger
      this.vmListItems = res.result;
      console.log(res);
      this.spinner.hide();
    }, (err) => {
      this.spinner.hide();
      console.log(err);
    })
  }

  getSaleList() {
    this._jq.showSpinner(true);
    debugger
    this._uow.gSaleService.GetGInstallmentBySaleIdAsync(this.urlId).subscribe((res: any) => {
      debugger
      this.vmListItems = res.result;
      console.log(res);
      this._jq.showSpinner();
    }, (err) => {
      console.log(err);
    })
  }

  getLatestPurchaseData() {
    this.spinner.show();
    debugger
    this._uow.gPurchaseService.GetGPurchaseByIdAsync(this.urlId).subscribe((res: any) => {
      this.vmListItem = res;
      this.vm = res;
      console.log(res);
      this.spinner.hide();
    }, (err) => {
      this.spinner.hide();
      console.log(err);
    })
  }

  hide() {
    debugger
    this.bsmRef.hide();
    if (this.calingUrl.startsWith('/purchase')) {
      this._router.navigateByUrl('/purchase', { replaceUrl: true }).then(() => {
        window.location.reload();
      });
    }

    if (this.calingUrl.startsWith('/direct-sale-dtl-view')) {
      this._router.navigateByUrl('/direct-sale-dtl-view', { replaceUrl: true }).then(() => {
        window.location.reload();
      });
    }

    if (this.calingUrl.startsWith('/direct-sale-list')) {
      this._router.navigateByUrl('/direct-sale-list', { replaceUrl: true }).then(() => {
        window.location.reload();
      });
    }

    if (this.calingUrl.startsWith('/payment-status')) {
      this._router.navigateByUrl('/payment-status', { replaceUrl: true }).then(() => {
        window.location.reload();
      });
    }

  }

  getLatestSaleData() {
    this._jq.showSpinner(true);
    debugger
    this._uow.gSaleService.GetGSaleByIdAsync(this.urlId).subscribe((res: any) => {
      this.vmListItem = res;
      this.vmS = res;
      console.log(res);
      this._jq.showSpinner();
    }, (err) => {
      console.log(err);
    })
  }

  getAccount(x: string) {
    debugger
    this._uow.gSettingService.GetAccountsBySearchAsync(x).subscribe((res: any) => {
      if (res) {
        this.accountList = res.result;
        console.log(res);
      }
    }, err => {
      console.log(err);
    });
  }

  openView(template: TemplateRef<any>, b, model?) {
    debugger
    this.openModalLg(template);
    let id = b.bulkPayment.name;
    debugger
    this._uow.gSaleService.GetGBulkPaymentByIdAsync(id).subscribe((res: any) => {
      debugger
      this.bulkbyid = res;
    }, (err) => {
      console.log(err);
    });
  }


  getSuppliers() {
    let supllier = AppConsts.SUPPLIER;
    if (this.vm.paymentType === 2) {
      supllier = "Cash";
    }

    this._uow.gSettingService.GetGCustomersDropDownAsync(supllier).subscribe((res: any) => {
      this.suppliers = res.result;
      this._uow.logger.log(this.suppliers);
    }, (err) => this._uow.logger.log(err));
  }

  getRefid() {
    this._uow.gPurchaseService.GetGPurchaseRefIdAsync().subscribe((res: any) => {
      console.log(res);
      this.vm.refId = res.code;
    }, (error) => {
      console.log(error);
    });
  }

  getRefSId() {
    this._uow.saleService.ValidateG_SaleRefId().subscribe((res: any) => {
      console.log(res);
      this.vm.refId = res.Code;
    }, (err) => {
      console.log(err);
    })
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this._uow.modalServiceEx.show(template);
  }

  openModalLg(template: TemplateRef<any>) {
    this.modalRef = this._uow.modalServiceEx.show(template);
    this.modalRef.setClass('modal-xl');
  }

  navigateClick() {
    this.isPreview = false;
    this.modalRef.hide()
  }

  public acountData: ItemViewModel1;
  onSelectSupplier(e) {
    debugger
    //console.log(e.target.value);
    let item = this.accountList.find(x => x.id === e.id);
    //  let i = new G_Installment_View_Model();
    //  i.G_Fk_DabitAccount_Id = new ItemViewModel();
    //  i.G_Fk_DabitAccount_Id.Id = item.Id;
    //  i.G_Fk_DabitAccount_Id.Name = item.Name;
    this.acountData = new ItemViewModel1();
    this.acountData.id = item.id;
    this.acountData.name = item.name;
  }

  public attachfile(event) {
    this.vmI.file = event.target.files[0];
  }

  saveOrUpdate() {
    debugger
    if (this.acountData == undefined || this.acountData.id == undefined || this.acountData.id == null) {
      Swal.fire(
        'Failure!',
        'Supplier/customer account not bind.',
        'error'
      )
      return;
    }
    this.spinner.show();
    debugger
    if (this.calingUrl.startsWith('/purchase')) {
      this.vmI.gPurchase = new ItemViewModel1();
      this.vmI.gPurchase.id = this.vm.id;
      this.vmI.gPurchase.name = "";
      this.vmI.debitAccount = new ItemViewModel1();
      this.vmI.debitAccount.id = this.vm.supCreditAcc.id;
      this.vmI.debitAccount.name = this.vm.supCreditAcc.name;
      this.vmI.creditAccount = new ItemViewModel1();
      this.vmI.creditAccount.id = this.acountData.id;
      this.vmI.creditAccount.name = this.acountData.name;
      this._uow.gPurchaseService
        //.PostInstallment(this.vmI)
        .SaveSpInstallmentAsync(this.vmI)
        .toPromise().then((res: any) => {
          this.submitted = true;
          this.spinner.hide();
          this.onSubmitted.emit(this.submitted);
          this.acountData = null;
          this.vmI.creditAccount = new ItemViewModel1();
          this.getLatestPurchaseData();
          this.getList();
          this.ngOnInit();
          Swal.fire(
            'Created!',
            'Added/Updated! Successfully',
            'success'
          )
          this.clearform();
        })
        .catch((error) => {
          Swal.fire(
            'Failure!',
            error.error.message,
            'error'
          )
          this.getList();
          this.spinner.hide();
          console.log(`Promise rejected with ${JSON.stringify(error)}`);
          this.onSubmitted.emit(false);
        });
    }
    if (this.calingUrl.startsWith('/direct-sale-dtl-view')) {
      debugger
      this.vmI.gSale = new ItemViewModel1();
      this.vmI.gSale.id = this.vmS.id;
      this.vmI.gSale.name = "";
      this.vmI.debitAccount = new ItemViewModel1();
      this.vmI.debitAccount.id = this.acountData.id;
      this.vmI.debitAccount.name = this.acountData.name;
      this.vmI.creditAccount = new ItemViewModel1();
      this.vmI.creditAccount.id = this.vmS.customerAcc.id;
      this.vmI.creditAccount.name = this.vmS.customerAcc.name;
      this._uow.purchaseService
        //.PostInstallment(this.vmI)
        .PostInstallment(null)
        .toPromise().then((res: any) => {
          this.submitted = true;
          console.log(res);
          this.onSubmitted.emit(this.submitted);
          this.getLatestSaleData();
          this.getSaleList();

          Swal.fire(
            'Created!',
            'Installment Added/Updated!',
            'success'
          )
          this.clearform();
        })
        .catch((error) => {
          Swal.fire(
            'Failure!',
            'Insallment Not Added/Updated!',
            'error'
          )
          this.getList();
          console.log(`Promise rejected with ${JSON.stringify(error)}`);
          this.onSubmitted.emit(false);
        });
    }

    if (this.calingUrl.startsWith('/direct-sale-list')) {
      debugger
      this.vmI.gSale = new ItemViewModel1();
      this.vmI.gSale.id = this.vmS.id;
      this.vmI.gSale.name = "";
      this.vmI.debitAccount = new ItemViewModel1();
      this.vmI.debitAccount.id = this.acountData.id;
      this.vmI.debitAccount.name = this.acountData.name;
      this.vmI.creditAccount = new ItemViewModel1();
      this.vmI.creditAccount.id = this.vmS.customerAcc.id;
      this.vmI.creditAccount.name = this.vmS.customerAcc.name;
      this.vmI.transactionDate = new Date(this.vmI.transactionDate);
      this._uow.gPurchaseService
        //.PostInstallment(this.vmI)
        .SaveSpInstallmentAsync(this.vmI)
        .toPromise().then((res: any) => {
          this.submitted = true;
          console.log(res);
          this.onSubmitted.emit(this.submitted);
          this.spinner.hide();
          this.getLatestSaleData();
          this.getSaleList();
          Swal.fire(
            'Created!',
            'Installment Added/Updated!',
            'success'
          )
          this.clearform();
        })
        .catch((error) => {
          Swal.fire(
            'Failure!',
            'Insallment Not Added/Updated!',
            'error'
          )
          this.getList();
          console.log(`Promise rejected with ${JSON.stringify(error)}`);
          this.onSubmitted.emit(false);
        });
    }

    if (this.calingUrl.startsWith('/payment-status')) {
      this.vmI.gSale = new ItemViewModel1();
      this.vmI.gSale.id = this.vmS.id;
      this.vmI.gSale.name = "";
      this.vmI.debitAccount = new ItemViewModel1();
      this.vmI.debitAccount.id = this.acountData.id;
      this.vmI.debitAccount.name = this.acountData.name;
      this.vmI.creditAccount = new ItemViewModel1();
      this.vmI.creditAccount.id = this.vmS.customerAcc.id;
      this.vmI.creditAccount.name = this.vmS.customerAcc.name;
      this._uow.gPurchaseService
        //.PostInstallment(this.vmI)
        .SaveSpInstallmentAsync(this.vmI)
        .toPromise().then((res: any) => {
          this.submitted = true;
          this.spinner.hide();
          this.onSubmitted.emit(this.submitted);
          this.getLatestSaleData();
          this.getSaleList();

          Swal.fire(
            'Created!',
            'Installment Added/Updated!',
            'success'
          )
          this.clearform();
        })
        .catch((error) => {
          Swal.fire(
            'Failure!',
            'Insallment Not Added/Updated!',
            'error'
          )
          this.getList();
          console.log(`Promise rejected with ${JSON.stringify(error)}`);
          this.onSubmitted.emit(false);
        });
    }

  }

  clearform() {
    this.vmI = new SaveGInstallmentRequest();
    this.vmI.transactionDate = new Date();
    this.vmI.amount = 0;
    this.vmI.remarks = "";
    this.vmI.debitAccount = new ItemViewModel1(0, "");
    this.vmI.creditAccount = new ItemViewModel1(0, "");
    this.acountData = new ItemViewModel1(0, "");
  }


  EditPurchaseInstallment(b) {
    debugger
    if (this.calingUrl.startsWith('/purchase')) {
      this.vmI.id = b.id;
      this.vmI.transactionDate = new Date(b.transactionDate);
      this.vmI.amount = b.amount;
      this.vmI.debitAccount = new ItemViewModel1(b.debitAccount.id, b.debitAccount.name);
      //this.vmI.creditAccount = b.creditAccount; //new ItemViewModel1(b.creditAccount.id, b.creditAccount.name);
      this.vmI.creditAccount = new ItemViewModel1(b.creditAccount.id, b.creditAccount.name);
      this.acountData = this.vmI.creditAccount;
      // this.instalment.FK_Account.Id = item.PaidFrom.Id;
      // this.instalment.FK_Account.Name = item.PaidFrom.Name;
      this.vmI.remarks = b.remarks;
      this.vmI.attachment = b.attachment;
      this.isEdit = true;
    }

    if (this.calingUrl.startsWith('/direct-sale-dtl-view')) {
      this.vmI.id = b.id;
      this.vmI.transactionDate = new Date(b.transactionDate);
      this.vmI.amount = b.amount;
      this.vmI.debitAccount = new ItemViewModel1(b.debitAccount.id, b.debitAccount.name);
      // this.instalment.FK_Account.Id = item.PaidFrom.Id;
      // this.instalment.FK_Account.Name = item.PaidFrom.Name;
      this.vmI.remarks = b.remarks;
      this.vmI.attachment = b.attachment;
    }

    if (this.calingUrl.startsWith('/direct-sale-list')) {
      this.vmI.id = b.id;
      this.vmI.transactionDate = new Date(b.transactionDate);
      this.vmI.amount = b.amount;
      this.vmI.debitAccount = new ItemViewModel1(b.debitAccount.id, b.debitAccount.name);
      this.vmI.creditAccount = new ItemViewModel1(b.creditAccount.id, b.creditAccount.name);
      // this.instalment.FK_Account.Id = item.PaidFrom.Id;
      // this.instalment.FK_Account.Name = item.PaidFrom.Name;
      this.vmI.remarks = b.remarks;
      this.vmI.attachment = b.attachment;
    }

    if (this.calingUrl.startsWith('/payment-status')) {
      debugger
      this.vmI.id = b.id;
      this.vmI.transactionDate = new Date(b.transactionDate);
      this.vmI.amount = b.amount;
      this.vmI.debitAccount = new ItemViewModel1(b.debitAccount.id, b.debitAccount.name);
      this.vmI.creditAccount = new ItemViewModel1(b.creditAccount.id, b.creditAccount.name);
      // this.instalment.FK_Account.Id = item.PaidFrom.Id;
      // this.instalment.FK_Account.Name = item.PaidFrom.Name;
      this.vmI.remarks = b.remarks;
      this.vmI.attachment = b.attachment;
      this.isEdit = true;
    }
  }

  compareFn(optionOne, optionTwo): boolean {
    debugger
    if (optionOne.id !== undefined && optionTwo !== undefined) {
      debugger
      if (optionOne.id !== null && optionTwo !== null) {
        debugger
        if (optionOne.id !== null && optionTwo.id !== undefined) {
          return optionOne.id === optionTwo.id;
        }

      }
    }
  }

  conformDelete() {
    this.spinner.show();
    if (this.calingUrl.startsWith('/purchase')) {
      //this._uow.purchaseService.DeleteInstallment(this.vmI).subscribe((res: any) => {
      this._uow.gPurchaseService.DeleteSpInstallmentAsync(this.deleteId).subscribe((res: any) => {
        this.getList();
        this.getLatestPurchaseData();
        this.ngOnInit();
        this.spinner.hide();
        Swal.fire(
          'Deleted!',
          'Installment Deleted!',
          'success'
        )
        this.modalRef.hide();
      }, (err) => {
        console.log(err);
        this.spinner.hide();
        Swal.fire(
          'Failure!',
          'Installment Not Deleted!',
          'error'
        )
      });
    }

    if (this.calingUrl.startsWith('/direct-sale-dtl-view')) {
      //this._uow.purchaseService.DeleteInstallment(this.vmI).subscribe((res: any) => {
      this._uow.purchaseService.DeleteInstallment(null).subscribe((res: any) => {
        this.getSaleList();
        this.getLatestSaleData();
        Swal.fire(
          'Deleted!',
          'Installment Deleted!',
          'success'
        )
        this.modalRef.hide();
      }, (err) => {
        console.log(err);
        Swal.fire(
          'Failure!',
          'Installment Not Deleted!',
          'error'
        )
      });
    }

    if (this.calingUrl.startsWith('/direct-sale-list')) {
      //this._uow.purchaseService.DeleteInstallment(this.vmI).subscribe((res: any) => {
      this._uow.gPurchaseService.DeleteSpInstallmentAsync(this.deleteId).subscribe((res: any) => {
        this.getSaleList();
        this.getLatestSaleData();
        this.spinner.hide();
        Swal.fire(
          'Deleted!',
          'Installment Deleted!',
          'success'
        )
        this.modalRef.hide();
      }, (err) => {
        console.log(err);
        Swal.fire(
          'Failure!',
          'Installment Not Deleted!',
          'error'
        )
      });
    }
    if (this.calingUrl.startsWith('/payment-status')) {
      //this._uow.purchaseService.DeleteInstallment(this.vmI).subscribe((res: any) => {
      this._uow.gPurchaseService.DeleteSpInstallmentAsync(this.deleteId).subscribe((res: any) => {
        this.getSaleList();
        this.getLatestSaleData();
        Swal.fire(
          'Deleted!',
          'Installment Deleted!',
          'success'
        )
        this.spinner.hide();
        this.modalRef.hide();
      }, (err) => {
        console.log(err);
        Swal.fire(
          'Failure!',
          'Installment Not Deleted!',
          'error'
        )
      });
    }
  }

  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    this.openModal(template);

  }

  // extrnal components
  onItemSubmitted(e) {
    console.log(e);
    if (e === true) {
      this.vmI = new SaveGInstallmentRequest();
    }
  }

  public deleteId: string;
  openDeleteModel(template: TemplateRef<any>, model?) {
    this.openModal(template);
    if (model !== undefined) {
      this.vmI = model;
      this.deleteId = model.uniqueId;
    }
  }
  public amountCheck: boolean = false;
  onEnterAmount() {
    debugger;

    const balance = Number((this.vmS.invAmount - this.vmS.paidAmount).toFixed(2));
    const balances = Number((this.vm.invAmount - this.vm.paidAmount).toFixed(2));
    const amount = Number((this.vmI.amount).toFixed(2));

    if (amount > balance || amount > balances) {
      this.amountCheck = true;
      return;
    }

    this.amountCheck = false;
  }
}
